import React, { useLayoutEffect } from 'react';
import { ChevronRight } from 'lucide-react';

import WaveBackground from '../components/shared/WaveBackground';
import Navbar from '../components/navigation/landing';
import Hero from '../components/landing/Hero';
import SolutionsSection from '../components/landing/SolutionsSection';
import TargetMarketSection from '../components/landing/TargetMarketSection';
import AdvantagesSection from '../components/landing/AdvantagesSection';
import PricingSection from '../components/landing/PricingSection';
import DeviceSection from '../components/landing/DeviceSection';
import Footer from '../components/landing/Footer';

/**
 * Landing Page — tek kaydırma modeli (window / document).
 * İç içe overflow ve body kilidi kaldırıldı; scroll her zaman açık.
 */
const Landing = () => {
  useLayoutEffect(() => {
    document.documentElement.classList.add('landing-scroll');
    return () => document.documentElement.classList.remove('landing-scroll');
  }, []);

  const navigateToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const sections = [
    { id: 'solutions', label: 'Our Solutions' },
    { id: 'target-market', label: 'Who is LAWNANCE for?' },
    { id: 'advantages', label: 'Why LAWNANCE?' },
    { id: 'plans', label: 'Pricing Plans' },
    { id: 'devices', label: 'Hardware Device Integration' },
  ];

  return (
    <div className="landing-page min-h-screen bg-main-gradient text-text-primary flex flex-col relative overflow-x-hidden font-inter">
      <WaveBackground variant="landing" />

      <Navbar />

      <main className="w-full shrink-0">
        <Hero />

        {/* Mobil: hızlı gezinme — tıklanınca ilgili bölüme kaydır (aynı sayfa) */}
        <div className="px-4 pb-6 md:hidden relative z-10">
          <p className="text-xs font-semibold uppercase tracking-wider text-white/50 mb-4 text-center">
            Quick Navigation
          </p>
          <div className="flex flex-col gap-2 max-w-md mx-auto">
            {sections.map((section) => (
              <button
                key={section.id}
                type="button"
                onClick={() => navigateToSection(section.id)}
                className="flex items-center justify-between p-4 rounded-xl border transition-all active:scale-98"
                style={{
                  background: 'rgba(255, 255, 255, 0.05)',
                  backdropFilter: 'blur(12px)',
                  WebkitBackdropFilter: 'blur(12px)',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  minHeight: '64px',
                }}
              >
                <span className="text-sm font-medium text-white">{section.label}</span>
                <ChevronRight size={20} className="text-white/50" />
              </button>
            ))}
          </div>
        </div>

        <SolutionsSection />
        <TargetMarketSection />
        <AdvantagesSection />
        <PricingSection />
        <DeviceSection />
      </main>

      <Footer />
    </div>
  );
};

export default Landing;
